var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.antiIndulgedLogin},[(_vm.antiInduledType)?_c('AntiIndulged',{ref:"antiInduled",attrs:{"branch":"login","type":_vm.antiInduledType,"isClient":true},on:{"submit":_vm.submit,"quitGame":_vm.quitGame,"close":_vm.close,"changeData":_vm.changeData,"confirm":_vm.confirm,"visitorModeLogin":_vm.visitorModeLogin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }